import UserLanguageSelect from "./user-language-select";


const UserFormItems = {
    LanguageSelect: UserLanguageSelect,
};

export default UserFormItems;